import React, { useEffect, useState } from "react";
import { Menu } from "antd";
import { TbCircleLetterT, TbRouteSquare } from "react-icons/tb";
import { FaMapLocation, FaRegHandshake, FaShop } from "react-icons/fa6";
import { FaProductHunt } from "react-icons/fa";
import { RiLogoutCircleLine } from "react-icons/ri";
import { Link, useLocation } from "react-router-dom";

import "../../style/modules/sidebar.scss";

const Sidebar = () => {
  const location = useLocation();
  const [activeKey, setActiveKey] = useState("");

  useEffect(() => {
    const path = location.pathname;
    const matchingItem = items.find((item) => item.path === path);
    if (matchingItem) {
      setActiveKey(matchingItem.key);
    } else {
      setActiveKey("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const handleMenuClick = (key) => {
    setActiveKey(key);
  };

  const handelLogout = () => {
    sessionStorage.clear();
    window.location.href = "/login";
  };

  const items = [
    {
      label: "Relays",
      key: "sub1",
      icon: <TbRouteSquare size={18} />,
      path: "/relays",
    },
    {
      label: "Routes",
      key: "sub2",
      icon: <FaMapLocation size={18} />,
      path: "/routes",
    },
    {
      label: "Suppliers",
      key: "sub3",
      icon: <FaShop size={18} />,
      path: "/suppliers",
    },
    {
      label: "Plants",
      key: "sub4",
      icon: <FaProductHunt size={18} />,
      path: "/plants",
    },
    {
      label: "Terminals",
      key: "sub5",
      icon: <TbCircleLetterT size={18} />,
      path: "/terminals",
    },
    {
      label: "Meeting Points",
      key: "sub6",
      icon: <FaRegHandshake size={18} />,
      path: "/meetingPoints",
    },
  ];

  return (
    <div className="sidebar">
      <div className="sidebar_logo">
        <img
          src="/unnamed.png"
          alt="Logo"
          style={{ width: "5rem", height: "5rem" }}
        />
      </div>
      <Menu
        className="sidebar_menu"
        mode="vertical"
        selectedKeys={[activeKey]}
        onClick={({ key }) => handleMenuClick(key)}
      >
        {items.map((item) => (
          <Menu.Item key={item.key} icon={item.icon}>
            <Link to={item.path} style={{ fontSize: "18px", fontWeight: 600 }}>
              {item.label}
            </Link>
          </Menu.Item>
        ))}

        <Menu.Item
          key="logout"
          icon={<RiLogoutCircleLine size={18} />}
          onClick={handelLogout}
          style={{
            position: "absolute",
            bottom: "5rem",
            fontSize: "18px",
            fontWeight: 500,
          }}
        >
          Logout
        </Menu.Item>
      </Menu>
    </div>
  );
};

export default Sidebar;
